import React from "react";

import classNames from "classnames";
import { Container, Image, Text } from "@atoms";
import { HeadingWIcon, Share } from "@molecules";
import brand from "@utils/brand";

const HeroArticle = ({
  image,
  heading,
  byline,
  copy,
  date,
  url,
  hasSidebar,
}) => {
  const { romero, lgca, lakota } = brand;
  return (
    <div className="relative z-0 w-full overflow-hidden pt-32 pb-6">
      <div className="relative z-10">
        <Container>
          <div className="flex flex-wrap items-center justify-center">
            <div className="mx-auto w-full md:w-1/2">
              {lakota && <HeadingWIcon icon="sunrise" heading={heading} />}
              {lgca && (
                <Text variant="h2-blog" className="font-serif text-blue">
                  {heading}
                </Text>
              )}
              {romero && (
                <Text variant="h2" className="font-serif text-blue">
                  {heading}
                </Text>
              )}
              <Text variant="body" className="my-4">
                {byline}
              </Text>
              <Text
                variant={romero ? "label" : "xs"}
                className={classNames("my-4", {
                  "text-gray": !romero,
                  "text-gold": romero,
                })}
              >
                {romero ? `${date}` : `Date: ${date}`}
              </Text>
              <Text variant={romero ? "body--xl" : "body--large-tight"}>
                {copy}
              </Text>
              <div className="mt-6">
                <Share small url={url} dark color={romero ? "blue" : "red"} />
              </div>
            </div>
            {(image || hasSidebar) && (
              <div className="mt-6 w-full md:mt-0 md:w-1/2 md:pl-12">
                {image && (
                  <div className="shadow-xl sm:-mr-10 md:-mr-12 lg:-mr-20 xl:-mr-24">
                    <Image image={image} />
                  </div>
                )}
              </div>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

HeroArticle.defaultProps = {};

export default HeroArticle;
